import type { WarchestGameMode } from "../multiplayer-game-store";

interface WarchestModeSelectProps {
  readonly onSelect: (mode: WarchestGameMode) => void;
}

// Host-only pre-game screen. The host picks how units are assigned before the
// `init` event is submitted; the guest waits on the loading screen until then.
export function WarchestModeSelect({ onSelect }: WarchestModeSelectProps) {
  return (
    <div
      className="flex flex-1 items-center justify-center p-6"
      data-testid="warchest-mode-select"
    >
      <div
        className="w-full max-w-md space-y-5 rounded-2xl p-6 text-center"
        style={{
          background: "var(--cn-warchest-card-bg)",
          border: "1px solid var(--cn-warchest-card-border)",
        }}
      >
        <div>
          <h1
            className="font-bold text-xl"
            style={{ color: "var(--cn-warchest-text)" }}
          >
            워체스트
          </h1>
          <p
            className="mt-1 text-sm"
            style={{ color: "var(--cn-warchest-text-muted)" }}
          >
            게임 모드를 선택하세요
          </p>
        </div>
        <div className="flex flex-col gap-3">
          <button
            type="button"
            data-testid="warchest-mode-quick"
            onClick={() => onSelect("quick")}
            className="rounded-lg px-4 py-3 text-left"
            style={{
              background: "var(--cn-warchest-valid-deploy)",
              border: "1px solid var(--cn-warchest-card-border)",
              color: "var(--cn-warchest-text)",
            }}
          >
            <div className="font-semibold text-sm">빠른 시작</div>
            <div
              className="text-xs"
              style={{ color: "var(--cn-warchest-text-muted)" }}
            >
              기본 유닛으로 바로 시작합니다.
            </div>
          </button>
          <button
            type="button"
            data-testid="warchest-mode-draft"
            onClick={() => onSelect("draft")}
            className="rounded-lg px-4 py-3 text-left"
            style={{
              background: "var(--cn-warchest-selected)",
              border: "1px solid var(--cn-warchest-card-border)",
              color: "var(--cn-warchest-text)",
            }}
          >
            <div className="font-semibold text-sm">드래프트</div>
            <div
              className="text-xs"
              style={{ color: "var(--cn-warchest-text)" }}
            >
              두 플레이어가 번갈아 유닛을 선택합니다.
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
